export const launchInfo = {
  launchTime: 1683547200000,
}